import TextArea from 'devextreme-react/text-area';
import React, { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { DangerButton, DefaultButton } from '../editor/button';
import ComboboxHoSoStatus from '../editor/cmbHoSoStatus';
const HoSoStatusSelectionModal = ({ onCancel, onSelected }) => {
    const [selectedId, setSelectedId] = useState(-1);
    const [ghiChu, setGhiChu] = useState('');
    return (
        <>
            <Modal
                open={true}
                size="mini"
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    <p>Chọn trạng thái</p>
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <div className="row">
                            <div className="col-md-12 padding-top-1rem">
                                <p>Chọn trạng thái</p>
                                <ComboboxHoSoStatus value={selectedId} onValueChanged={(value) => setSelectedId(value)} />
                            </div>
                            <div className="col-md-12 padding-top-1rem">
                                <p>Ghi chú</p>
                                <TextArea autoResizeEnabled
                                    stylingMode='outlined'
                                    onValueChanged={(e) => {
                                        if (e.event) setGhiChu(e.value)
                                    }} />
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>

                        <DefaultButton text={"Đóng"} onClick={onCancel} />
                        <DangerButton disabled={selectedId <= 0} text={"Cập nhật"} onClick={() => {
                            onSelected(selectedId, ghiChu)
                        }} />
                    </div>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default HoSoStatusSelectionModal;